import * as wand from '$lib/api/wand';
import type {
  WandExecutorContract,
  WandMethodInfo,
} from '@helinks/wand-api-thrift/wand_types';

export type ExecutorContractCatalogState =
  | { status: 'idle'; contracts: null }
  | { status: 'loading'; contracts: WandExecutorContract[] | null }
  | { status: 'ready'; contracts: WandExecutorContract[] }
  | { status: 'error'; contracts: WandExecutorContract[] | null; error: unknown };

let state = $state<ExecutorContractCatalogState>({ status: 'idle', contracts: null });

export function getContractsState(): ExecutorContractCatalogState {
  return state;
}

function requireContracts(): WandExecutorContract[] {
  if (state.status === 'ready') return state.contracts;
  if (state.status === 'error') throw state.error;
  throw new Error(`Executor contract catalog is ${state.status}`);
}

export function getContract(id: string): WandExecutorContract {
  if (!id) throw new Error('Executor contract id is required');
  const contract = requireContracts().find((candidate) => candidate.id === id);
  if (!contract) throw new Error(`Executor contract ${id} is unavailable`);
  return contract;
}

export function contractLabel(contract: WandExecutorContract): string {
  return `${contract.serviceName} (${contract.astSha256.slice(0, 12)})`;
}

export function getServiceMethods(contractId: string): WandMethodInfo[] {
  if (!contractId) throw new Error('Executor contract id is required');
  return getContract(contractId).schema.methods;
}

export async function fetchContracts(): Promise<void> {
  const contracts = state.contracts;
  state = { status: 'loading', contracts };
  try {
    state = { status: 'ready', contracts: await wand.listExecutorContracts() };
  } catch (error) {
    state = { status: 'error', contracts, error };
    throw error;
  }
}
